var app = new Vue({
    el: '#app',
    data: {
        index: 0,
        tournaments: [
            {
                name: 'lol',
                title: '英雄聯盟賽事',
                logo: require('./assets/lol.png'),
                timetable: [
                    {
                        dateline: require('./assets/lol-date1-v2.png'),
                        content: require('./assets/state_openregistration.png')
                    },
                    {
                        dateline: require('./assets/lol-date2.png'),
                        content: require('./assets/state_announcebracket.png')
                    },
                    {
                        dateline: require('./assets/lol-date3.png'),
                        content: require('./assets/state_online128.png')
                    },
                    {
                        dateline: require('./assets/lol-date4.png'),
                        content: require('./assets/state_offlinefinal.png')
                    }
                ]
            },
            {
                name: 'aov',
                title: '傳說對決賽事',
                logo: require('./assets/aov.png'),
                timetable: [
                    {
                        dateline: require('./assets/aov-date1-v2.png'),
                        content: require('./assets/state_openregistration.png')
                    },
                    {
                        dateline: require('./assets/aov-date2.png'),
                        content: require('./assets/state_announcebracket.png')
                    },
                    {
                        dateline: require('./assets/aov-date3.png'),
                        content: require('./assets/state_online128.png')
                    },
                    {
                        dateline: require('./assets/aov-date4.png'),
                        content: require('./assets/state_offlinefinal.png')
                    }
                ]
            },
            {
                name: 'hearthstone',
                title: '爐石戰記賽事',
                logo: require('./assets/hearthstone.png'),
                timetable: [
                    {
                        dateline: require('./assets/aov-date1-v2.png'),
                        content: require('./assets/state_openregistration.png')
                    },
                    {
                        dateline: require('./assets/aov-date2.png'),
                        content: require('./assets/state_announcebracket.png')
                    },
                    {
                        dateline: require('./assets/hearthstone-date3-v2.png'),
                        content: require('./assets/state_online128_remark.png')
                    },
                    {
                        dateline: require('./assets/hearthstone-date4.png'),
                        content: require('./assets/state_offlinefinal.png')
                    }
                ]
            }
        ]
    },
    computed: {
        currentTournament: function() {
            return this.tournaments[this.index];
        },
        previousTournament: function() {
            if (this.index - 1 < 0) {
                return this.tournaments[this.tournaments.length - 1];
            }
            return this.tournaments[this.index - 1];
        },
        nextTournament: function() {
            if (this.index + 1 >= this.tournaments.length) {
                return this.tournaments[0];
            }
            return this.tournaments[this.index + 1];
        }

    },
    methods: {
        next: function() {
            this.index++;
            if(this.index >= this.tournaments.length) {
                this.index = 0;
            }
        },
        prev: function() {
            this.index--;
            if(this.index < 0) {
                this.index = this.tournaments.length - 1;
            }
        }
    }
})